import { createContext, useContext } from 'react';
import type { Editor } from '@tiptap/core';

interface EditorContextValue {
  addImage: (image: File, imageId?: string, alt?: string, actionUrl?: string) => void;
  editor: Editor | null;
}

const EditorContext = createContext<EditorContextValue>({
  addImage: () => {},
  editor: null
});

export const useEditorContext = () => {
  return useContext(EditorContext);
};

export default EditorContext;
